import { render, staticRenderFns } from "./handicapPrice.vue?vue&type=template&id=c19607a8&scoped=true"
import script from "./handicapPrice.vue?vue&type=script&lang=js"
export * from "./handicapPrice.vue?vue&type=script&lang=js"
import style0 from "./handicapPrice.vue?vue&type=style&index=0&id=c19607a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19607a8",
  null
  
)

export default component.exports